import React, { useEffect } from "react";
import "./App.css";
import { getApp } from "./utils/helpers";

const App: React.FC = () => {
  const CurrentApp = getApp();

  useEffect(() => {
    const interval = setInterval(() => {
      //console.log("Refreshing the page...");
      window.location.reload();
    }, 300000); // 5 minutes in milliseconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
      <>
        <div>
          <div>
            <CurrentApp />
          </div>
        </div>
      </>
  );
};

export default App;

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  padding: {
    paddingLeft: 60,
    paddingTop: 6,
  },
} as const;